<div [formGroup]="form">
<div class="input-group position-relative">
  <input
    type="text"
    class="form-control input-font"
    [formControlName]="field.name"
    (input)="filterOptions()"
 

   [placeholder]="field.placeholder"
  />
  <span class="input-group-text">
    <img src="../../../assets/images/search_icon.svg" />
  </span>
</div>

@if (form.controls[this.field.name].value.length >0 &&filteredOptions.length){
<ul class="autocomplete-dropdown">
  @for (option of filteredOptions; track option) {
    <li
      [class.disabled]="option.disabled"
      (mousedown)="!option.disabled && selectOption(option)">
      {{ option.name }}
    </li>
  }
</ul>

}
  
    @if(form.get(field.name)?.invalid && form.get(field.name)?.touched){
        <small class="invalid-feedback">{{field.label}} is required</small>
        }
   
</div>
